import type { ScopeKind } from "../../../../../shared/rbac/permissions";

type Grant = {
  customRoleId: string | null;
  builtinRoleId: string | null;
  scopeId: string;
};

type GroupForRole = {
  id: string;
  roleGrantsAsScope: readonly Grant[];
  roleGrantsAsPrincipal: readonly Grant[];
};

export type GroupWithScopes<G> = { group: G; scopeIds: string[] };

export function findGroupsForRole<G extends GroupForRole>(
  groups: readonly G[],
  roleId: string,
  scopeKind: ScopeKind,
  isBuiltin: boolean
): GroupWithScopes<G>[] {
  const source: "roleGrantsAsScope" | "roleGrantsAsPrincipal" =
    scopeKind === "user_group" ? "roleGrantsAsScope" : "roleGrantsAsPrincipal";
  const result: GroupWithScopes<G>[] = [];
  for (const group of groups) {
    const matching = group[source].filter((gr) =>
      isBuiltin ? gr.builtinRoleId === roleId : gr.customRoleId === roleId
    );
    if (matching.length === 0) continue;
    if (scopeKind === "user_group") {
      result.push({ group, scopeIds: [group.id] });
      continue;
    }
    const seen = new Set<string>();
    const scopeIds: string[] = [];
    for (const gr of matching) {
      if (seen.has(gr.scopeId)) continue;
      seen.add(gr.scopeId);
      scopeIds.push(gr.scopeId);
    }
    result.push({ group, scopeIds });
  }
  return result;
}
